import { determineTopicFile } from "../xmlUtils";

export function formatTopicResults(topicsToProcess, {
  top = 10,
  skip = 0
}) {

  return topicsToProcess.slice(skip, skip + top).map((topicResult) => {
    const guideline = topicResult.g;
    const topicFile = determineTopicFile(guideline, topicResult);
    const guidelinePath = guideline.replace(/ /g, "_");
    const generateUrl = `/viewTopic?etgAccess=true&guidelinePage=${encodeURIComponent(guidelinePath)}&navigateTopic=${topicFile}.ditamap#toc|0`;
    return {
      title: topicResult.s,
      url: generateUrl,
      guideline: topicResult.g,
      score: 0
    };
  });
}